import React                    from 'react';
import PropTypes                from 'prop-types';
import {TileDisplayConfigType}  from "../Grid2";
import ReloadHelper             from "../../../utils/ReloadHelper";
import Translations             from "../../../utils/Translations";
import { trackCategoriesClick } from '../../../utils/GAHelper';



const CategoriesTile = props => {
	const data    = props.data;
	const onClick = e => {
		trackCategoriesClick(data.id, data.linkVX);
		ReloadHelper.reload(data.linkVX, e);
	};

	return (
		<a className={'h-disp-block maincategories-picture'} href={data.linkVX} onClick={onClick}>
			<img src={data.imageUrl} loading={"lazy"}/>
			<div className="grid-2__item__collection">
				{React.createElement(
					props.headlineType,
					{className: 'grid-2__item__collection-name'},
					props.data.label || props.data.name,
				)}
				<div className="grid-2__item__collection-count">{props.data.modelCount} {(props.data.modelCount > 1 ? Translations.get('CollectionSearchResultCountPlural') : Translations.get('CollectionSearchResultCountSingular'))}</div>
			</div>
		</a>
	);
};

CategoriesTile.propTypes = {
	data:          PropTypes.object.isRequired,
	displayConfig: TileDisplayConfigType.isRequired,
	headlineType:  PropTypes.string,
};

CategoriesTile.defaultProps = {
	headlineType: 'div',
};

export default CategoriesTile;
